import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareOnboardingRoute: InvariantJiraRoute = {
	name: 'software-onboarding',
	path: '/welcome/software',
	exact: true,
};
